/* global google: false */
import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ReservationActions from '../../actions/Reservation.js';

const styles = {
  wrap: {
    border: '2px solid #FFF',
    borderRadius: 2,
    width: '100%',
    height: 250,
    margin: '24px auto',
    position: 'relative',
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      height: 300,
    },
  },
  map: {
    height: 250,
    '@media (max-width: 767px)': {
      height: 300,
    },
  },
  text: {
    position: 'absolute',
    bottom: 4,
    left: 4,
    textAlign: 'center',
    fontSize: 12,
  },
};

class ReservationDetailMap extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      isGoogleMapLoaded,
    } = this.props;

    if (isGoogleMapLoaded) {
      this.initMap();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isGoogleMapLoaded && !this.props.isGoogleMapLoaded) {
      this.initMap();
    }
  }

  initMap() {
    const {
      map,
    } = this.refs;

    const {
      shop,
    } = this.props;

    if (!shop) return null;

    this.map = new google.maps.Map(map, {
      center: {
        lat: parseFloat(shop.lat),
        lng: parseFloat(shop.lng),
      },
      zoom: 15,
    });

    this.marker = new google.maps.Marker({
      map: this.map,
      position: {
        lat: parseFloat(shop.lat),
        lng: parseFloat(shop.lng),
      },
    });

    return google.maps.event.addListenerOnce(this.map, 'idle', () => {

    });
  }

  render() {
    return (
      <div style={styles.wrap}>
        <div style={styles.map} ref="map" />
      </div>
    );
  }
}


ReservationDetailMap.defaultProps = {
  isGoogleMapLoaded: false,
};

ReservationDetailMap.propTypes = {
  shop: T.object,
  isGoogleMapLoaded: T.bool,
};

export default connect(
  state => ({
    isGoogleMapLoaded: state.Map.isLoaded,
  }),
  dispatch => bindActionCreators(ReservationActions, dispatch),
)(radium(ReservationDetailMap));



// WEBPACK FOOTER //
// ./containers/Reservations/ReservationDetailMap.js